import { mapRef } from "@knyt/artisan";
/**
 * Creates an accessor that provides access to selected values from
 * a given `Reference`.
 *
 * @internal scope: workspace
 */
export function createAccessor(reference, input) {
    const accessor = {};
    for (const key in input) {
        const selector = input[key];
        const selectorKey = `select${key.charAt(0).toUpperCase()}${key.slice(1)}`;
        const selectedRefKey = `${key}$`;
        const selectedRef = mapRef(reference, selector);
        accessor[selectedRefKey] = selectedRef;
        accessor[selectorKey] = selector;
        Object.defineProperty(accessor, key, {
            // The `selectedRef` shouldn't be used, because it's updated asynchronously.
            // Instead, use the selector function to get the current value from the original reference.
            // If the selector is memoized, like it should be, this potentially running the selector function
            // directly on the reference shouldn't be a performance issue even if the selector is computationally expensive.
            get: () => selector(reference.value),
        });
    }
    accessor.$values = () => {
        const props = {};
        for (const key in input) {
            const selector = input[key];
            props[key] = selector(reference.value);
        }
        return props;
    };
    return accessor;
}
